<div class="flex flex-row items-center justify-center gap-2">
  <div [ngClass]="menuService.showSideBar ? 'w-[36px]' : 'h-8 w-8'" class="flex-shrink-0 transition-all duration-300">
    <img alt="Logo do PacPro" height="168" ngSrc="assets/logo-pacpro-only.png" width="168" />
  </div>
  <div
    [ngClass]="[
      !menuService.showSideBar ? 'duration-150 md:invisible md:w-0 md:opacity-0' : 'delay-150 duration-300 lg:flex',
    ]"
    class="flex flex-col sm:flex"
  >
    <h1 class="text-2x font-bold text-content-secondary">PacPro</h1>
    <span class="text-xs text-content-secondary">Gestão de Autocontrole</span>
  </div>
</div>
